import { createContext, useContext } from 'react';

export type ReportErrorFn = (errorMessage: string) => void;

export const ReportErrorContext = createContext<ReportErrorFn>(
  () => { window.location.reload(); },
);

export function useReportError(): ReportErrorFn {
  return useContext(ReportErrorContext);
}
